export default __webpack_public_path__ + "static/media/794153eb235da180.7832577e3f6a8aa9122181b9adef755e.svg";